var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.35V25.65C24 30.9 21.9 33 16.65 33H10.35C5.1 33 3 30.9 3 25.65V19.35C3 14.1 5.1 12 10.35 12H16.65C21.9 12 24 14.1 24 19.35Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 10.35V16.65C33 21.9 30.9 24 25.65 24H24V19.35C24 14.1 21.9 12 16.65 12H12V10.35C12 5.1 14.1 3 19.35 3H25.65C30.9 3 33 5.1 33 10.35Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinear);
export default __webpack_public_path__ + "static/media/linear.c6de97906ffbee78623f93fae5c6b7eb.svg";
export { ForwardRef as ReactComponent };